<template>
  <ul ref="listRef">
    <template v-for="item in list" :key="item">
      <li v-if="item">{{ item }}</li>
    </template>
  </ul>
</template>

<script lang="ts" setup>
interface Props {
  list: string[]
}

defineProps<Props>()

const listRef = ref<Nullable<HTMLElement>>(null)

defineExpose({ listRef })
</script>

<style lang="scss" scoped>
li {
  @apply relative pl-5;
  &:before {
    content: '';
    @apply inline-block absolute left-1 top-2 align-middle size-1 bg-black-80 rounded-full;
  }
}
</style>
